import * as React from 'react';

import {IframeComponent} from 'shells/iframe/iframe-component';

import {PageContainer, PageTitleBar} from '../../../layout';

export function CrmAdvertisingPage() {
    return (
        <PageContainer
            title='CRM advertising'
            noPadding={true}
            pageTitleBar={
                <PageTitleBar
                    title='CRM advertising'
                    subheaderPrimaryText='Data-driven advertising campaigns with WebFX'
                />
            }
        >
            <IframeComponent
                src='https://www.nutshell.com/martech-solutions'
                title='CRM advertising'
            />
        </PageContainer>
    );
}
